// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2957":"a04cbb144eed9bf8e961","5338":"6ef9ef2074a877567ecc"}[chunkId] + ".js";
};